import styled from 'styled-components'
import { DateTimePickerUnstyled } from './unstyled'

export const DateTimePicker = styled(DateTimePickerUnstyled)`
  .label {
    display: block;
    padding: 0;
    text-align: left;
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    line-height: 24px;
    margin: 0 0 10px 0;
  }

  hr {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Form/DateTimePicker/index.js